export default __webpack_public_path__ + "static/media/risk_manager.bc09bebc.png";